import { AccountingPeriod } from '@models/accounting-period';
import { Contributor } from '@models/contributor';
import { Company } from '@modules/core/models/company';

import { FormalityBase, FormalityBaseJson } from './formality-base';
import { FormalitySpecificDates } from './formality-specific-dates';
import { LegalFormalityStatus } from './legal-formality-status';
import { LegalMoralPerson, LegalMoralPersonJson } from './legal-moral-person';
import { LegalPhysicalPerson, LegalPhysicalPersonJson } from './legal-physical-person';
import { FormalitySupervisorEnum } from '../enums/formality-supervisor.enum';

export interface CapitalDepositFormalityJson extends FormalityBaseJson {
  moral_persons?: Partial<LegalMoralPersonJson>[];
  users?: Partial<LegalPhysicalPersonJson>[];
  main_user_id?: number;
}

export class CapitalDepositFormality extends FormalityBase {
  constructor(
    public id?: number,
    public formalityType?: string,
    public codeName?: string,
    public status?: string,
    public formalitySupervisor?: FormalitySupervisorEnum,
    public deliveryDate?: Date,
    public statuses?: LegalFormalityStatus[],
    public businessUnitId?: number,
    public production?: Contributor,
    public note?: string,
    public accountingPeriod?: AccountingPeriod,
    public company?: Company,
    public specificDates?: FormalitySpecificDates,
    public moralPersons?: LegalMoralPerson[],
    public users?: LegalPhysicalPerson[],
    public mainUserId?: number
  ) {
    super(
      id,
      formalityType,
      codeName,
      status,
      formalitySupervisor,
      deliveryDate,
      statuses,
      businessUnitId,
      production,
      note,
      accountingPeriod,
      company,
      specificDates
    );
  }

  static fromJson(json: Partial<CapitalDepositFormalityJson>): CapitalDepositFormality {
    let capitalDepositFormality = new CapitalDepositFormality();

    capitalDepositFormality = Object.assign(capitalDepositFormality, FormalityBase.fromJson(json));

    capitalDepositFormality.moralPersons = json.moral_persons
      ? json.moral_persons.map(moralPerson => LegalMoralPerson.fromJson(moralPerson))
      : [];

    capitalDepositFormality.users = json.users ? json.users.map(user => LegalPhysicalPerson.fromJson(user)) : [];

    capitalDepositFormality.mainUserId = json.main_user_id ? json.main_user_id : null;

    return capitalDepositFormality;
  }

  static toJson(capitalDepositFormality: Partial<CapitalDepositFormality>): Partial<CapitalDepositFormalityJson> {
    return {
      ...FormalityBase.toJson(capitalDepositFormality),

      moral_persons: capitalDepositFormality.moralPersons
        ? capitalDepositFormality.moralPersons.map(moralPerson => LegalMoralPerson.toJson(moralPerson))
        : [],

      users: capitalDepositFormality.users
        ? capitalDepositFormality.users.map(user => LegalPhysicalPerson.toJson(user))
        : [],

      main_user_id: capitalDepositFormality.mainUserId ? capitalDepositFormality.mainUserId : null
    };
  }

  static toMainUserIdFormalityJson(formality: Partial<CapitalDepositFormality>): Partial<CapitalDepositFormalityJson> {
    return {
      id: formality.id,
      main_user_id: formality.mainUserId ? Number(formality.mainUserId) : null
    };
  }
}
